import { ExtraChargesType } from "@/types/business/extraCharges.Type";
import { TaxInterface } from "@/interface/business/item.interface";
import { PermissionsConstrains } from "@/enums/permissions.enum";
import { PriceMoney } from "@/modules/location";
import { CHARGES } from "@/enums/ooc/ooc-order.enum";
import { FORM_TYPE } from "@/enums/apps.enum";
import { EXTRA_CHARGE_TYPE } from "@/enums/orders.enum";

export class ExtraCharge {
  id: string = "";
  name: string = "";
  displayName: string = "";
  type: string = "FIXED";
  rate: number = 0;
  amount: number = 0;
  price: string = new PriceMoney({ amount: 0 }).getPricePackage();
  formType: string = FORM_TYPE.CREATE;
  tax?: TaxInterface;

  public static MODULE_NAME = PermissionsConstrains.BUSINESS_EXTRA_CHARGE;

  constructor(data?: ExtraChargesType) {
    if (data) {
      this.id = data.id;
      this.name = data.name;
      this.type = data.type;
      this.rate = data.rate;
      this.amount = data.amount;
      this.tax = data.tax;
      this.price = new PriceMoney({ amount: data.amount }).getPricePackage();
      this.prepareOOCDisplayName();
    }
  }

  deleteID() {
    delete this.id;
  }

  /**
   * will divide the rate by 100 and convert to percentage , only it is more than 1
   */
  public setupRate() {
    this.rate = Number((this.rate / 100).toFixed(2));
  }

  handleMultiplyRate() {
    this.rate = this.rate * 100;
  }

  /**
   * checks the name of the charge and assign the translation key for it .
   */
  prepareOOCDisplayName() {
    if (this.name === CHARGES.SERVICE) {
      this.displayName = "service_charge";
    }
  }

  /**
   * assign rate value to rate , if rate is empty will assign it to -1
   */
  public setRate(rate) {
    if (!rate) {
      this.rate = -1;
      return;
    }
    this.rate = rate / 100;
    this.rate.toFixed(2);
  }

  /**
   * assign rate value to rate , if rate is empty will assign it to -1
   */
  public setAmount(amount) {
    if (!amount) {
      this.amount = -1;
      return;
    }
    this.amount = amount * 1000;
  }

  /**
   * Get Extra charges amount | rate value
   * @return {string}
   */
  public getValue(): string {
    if (this.type === EXTRA_CHARGE_TYPE.FIXED) {
      return new PriceMoney({ amount: this.amount }).getPricePackage();
    }

    return `${this.getRateValue()}%`;
  }

  /**
   * Get Extra charges rate value
   * @return {number}
   */
  public getRateValue(): number {
    return this.rate * 100;
  }
}
